import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

interface IFinanceConfigChangeUpdateTaxPayload {
  cgst: number;
  sgst: number;
  igst: number;
  utgst: number;
}

interface IFinanceConfigChangeUpdatePayload {
  request_id: string;
  outward_tax_details: {
    hsn_code: string;
    tax: IFinanceConfigChangeUpdateTaxPayload;
  };
  category_subcategory_details: {
    id: string;
    name: string;
    sub_category_id: string;
    sub_category_name: string;
  };
}

interface IFinanceConfigChangeUpdateResponse {
  status: boolean;
  message?: string;
}

export const useFinanceConfigChangeUpdateAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (payload: IFinanceConfigChangeUpdatePayload) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.patch<IFinanceConfigChangeUpdateResponse>(
          INVENTORY_MODULE?.FINANCE_CONFIG_CHANGE_ACTION?.baseURL ?? "",
          payload,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        return {
          status: response.data?.status === true,
          message: response.data?.message ?? "",
        };
      } catch (e: unknown) {
        const error = e as AxiosError;
        sendCurl(error?.config?.["curlCommand"]);
        captureError(error);
        return {
          status: false,
          message: error?.message ?? "Failed to update requested tax details",
        };
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { execute };
};
